var _rect, _rect2, _rect3, _rect4, _rect5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLatencyExcellent = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 14,
    viewBox: "0 0 9 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 12,
    width: 8.94737,
    height: 2,
    fill: "#92C353"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 9,
    width: 8.94737,
    height: 2,
    fill: "#92C353"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 6,
    width: 8.94737,
    height: 2,
    fill: "#92C353"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    y: 3,
    width: 8.94737,
    height: 2,
    fill: "#92C353"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 8.94737,
    height: 2,
    fill: "#92C353"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLatencyExcellent);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Latency_excellent.fb1325e80b28852c3310c1032cbc23cc.svg";